// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8172":"1c8400d8","8427":"1c8400d8"}[chunkId] + ".chunk.css";
};